import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  topSection: {
    padding: '40px 0',
    backgroundColor: theme.palette.background.paper,
  },
  articleTitle: {
    margin: '16px 0 8px',
    fontSize: 32,
    lineHeight: '125%',
  },
  loaderWrapper: {
    backgroundColor: theme.palette.background.paper,
    minHeight: 300,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  articlePreview: {
    whiteSpace: 'pre-line',
  },
  authorBlock: {
    marginTop: 24,
    display: 'flex',
    alignItems: 'center',
    '& img': {
      marginRight: '0.5ch',
      width: 40,
      height: 40,
      borderRadius: '50%',
      overflow: 'hidden',
    },
  },
  articleDate: {
    paddingLeft: '0.5ch',
    color: theme.palette.info.main,
    '&:before': {
      content: '"•"',
      paddingRight: '0.5ch',
    },
  },
  articleImage: {
    margin: '24px 0',
    width: '100%',
    aspectRatio: '346/134',
    position: 'relative',
    borderRadius: 24,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
    '& img': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '100%',
      height: 'auto',
    },
  },
  contentSection: {
    padding: '40px 0',
    backgroundColor: theme.palette.background.default,
  },
  articleContent: {
    '& > *:first-child': {
      marginTop: 0,
    },
    '& h3': {
      marginBottom: 8,
      marginTop: 0,
    },
    '& h2': {
      marginBottom: 24,
      marginTop: 48,
    },
    '& a': {
      cursor: 'pointer',
      display: 'inline',
      fontWeight: 700,
      color: theme.palette.primary.dark,
    },
    '& li::marker': {
      fontSize: 18,
      color: theme.palette.secondary.dark,
    },
  },
  [theme.breakpoints.up('sm')]: {
    topSection: {
      padding: '56px 0',
      '& h1, p': {
        maxWidth: 450,
      },
    },
    articleContent: {
      '& > *': {
        maxWidth: 450,
      },
    },
  },
  [theme.breakpoints.up('md')]: {
    articleTitle: {
      fontSize: 48,
    },
    topSection: {
      padding: '80px 0',
      '& h1, p': {
        maxWidth: 641,
      },
    },
    articleContent: {
      '& > *': {
        maxWidth: 641,
      },
    },
    articleImage: {
      maxWidth: 641,
    },
  },
}));

export default useStyles;
